import { z } from "zod";
import { env } from "../config";

const networxWindowDataSchema = z.object({
  autofillZip: z.string().nullish(),
  is_st_co_selection: z.boolean().nullish(),
  homeowner_token: z.string().nullish(),
  admin_token: z.string().nullish(),
  homeowner_id: z.string().nullish(),
  default_location: z.object({
    zip: z.string(),
    city: z.string(),
    state: z.string(),
  }).nullish(),
  session_id: z.string().nullish(),
  lead_phone: z.string().nullish(),
  tcpa_text: z.string().nullish(),
  gmap_api_key: z.string().nullish(),
  preference_to: z.string().optional(),
  feature_tests: z.record(z.string(), z.object({
    variant: z.enum(["control", "compare"]),
    active: z.boolean(),
  })).nullish(),
  signup_networks: z.record(z.union([z.string(), z.string()])).nullish(),
  zip_code: z.string().nullish(),
});

export function getNetworxDataFromWindow(opts?: { skipDevValues?: boolean }) {
  if (!opts?.skipDevValues && env.isDev) {
    window.session_id ??= env.SESSION_ID;
    window.homeowner_id ??= env.HOMEOWNER_ID;
    window.homeowner_token ??= env.HOMEOWNER_TOKEN;
    window.is_st_co_selection ??= env.FF_CO_SELECTION;
    window.feature_tests ??= JSON.parse(env.FEATURE_TESTS ?? "{}");
    window.lead_phone ??= env.LEAD_PHONE;
    window.tcpa_text = `<p class="tcpa-text">By submitting I agree to Networx <a href="https://networx.ariel.networx.link/privacy" target="_blank" style="color: inherit; text-decoration: underline;  ">Privacy</a> and that Networx and its <a href="https://networx.ariel.networx.link/terms-use#third-party" target="_blank" style="color: inherit; ">partners</a> may call, or text me to follow-up about my home improvement project, or provide other offers, using automated technology, at the phone number I provided. Consent is not a condition of purchase. You can opt-out at any time by replying 'STOP' to any text message or by contacting us directly. Message and data rates may apply.</p>`;
    window.gmap_api_key = env.GMAP_API_KEY;
    window.signup_networks ??= env.SIGNUP_NETWORKS;
    window.zip_code ??= env.ZIP_CODE;
  }
  const parse = networxWindowDataSchema.safeParse(window);
  const data = parse.success ? parse.data : window as z.infer<typeof networxWindowDataSchema>;
  return data;
}

/**
 * This is read when the app first load and then never changes,
 * opt to use the getNetworxDataFromWindow() function to get the real-time data,
 * in case someone changes the data
 */
export const global = getNetworxDataFromWindow();

declare global {
  interface Window extends z.infer<typeof networxWindowDataSchema> {}
}
